<template>
  <a-layout class="layout">
    <a-layout-content :class="[{'mobile-style': isMobile, 'pc-style': !isMobile}]">
      <a-breadcrumb style="margin: 16px 0">
      </a-breadcrumb>
      <div :style="{ background: '#fff', padding: '24px', minHeight: '280px' }">
        <a-menu v-model:selectedKeys="currentMenu" mode="horizontal" :items="items"/>

        <a-table
            :columns="columns"
            :row-key="record => record.id"
            :data-source="data"
            :pagination="pagination"
            :loading="loading"
            @change="handleTableChange"
            style="margin-top: 10px;"
            :show-total="total => `Total ${total} items`"
        >
          <template #bodyCell="{ column, record }">
            <template v-if="column.key === 'process_desc'">
              <a-tag color="processing" v-if="['unverified', 'submitted'].includes(record.process)">{{ record.process_desc }}</a-tag>
              <a-tag color="success" v-else-if="record.process === 'approved'">{{ record.process_desc }}</a-tag>
              <a-tag color="warning" v-else-if="['verified', 'rejected'].includes(record.process)">{{ record.process_desc }}</a-tag>
              <a-tag color="default" v-else>{{ record.process_desc }}</a-tag>
            </template>
            <template v-else-if="column.key === 'action'">
              <span>
                <a v-if="record.process === 'verified'" :href="'/claim-prize?id=' + record.id" style="color: #faad14;">Pending submission</a>
                <a v-else :href="'/claim-detail/' + record.id">Detail</a>
              </span>
            </template>
          </template>
        </a-table>
      </div>
    </a-layout-content>
    <a-layout-footer style="text-align: center; height: 0px;">
    </a-layout-footer>
  </a-layout>
</template>

<script setup>
import {h, ref, reactive, inject} from 'vue';
import {message} from "ant-design-vue";
import {allList} from "@/services/freeProduct";
import {usePagination} from "vue-request";
import {claimHistory} from "@/services/claimPrize";

const isMobile = inject('isMobile');
const showLogin = inject('showLogin');
showLogin.value = false;

const currentMenu = ref(['claim-history']);
const items = ref([
  {
    key: 'claim-prize',
    label: h(
        'a',
        {
          href: '/claim-prize',
        },
        'Claim Reward'
    ),
    title: 'Claim Reward',
  },
  {
    key: 'claim-history',
    label: h(
        'a',
        {
          href: '/claim-history',
        },
        'Claim History',
    ),
    title: 'Claim History',
  },
]);


const columns = [
  {
    title: 'Code',
    dataIndex: 'code',
    key: 'code',
  },
  {
    title: 'Order Id',
    dataIndex: 'order_id',
    key: 'order_id',
  },
  {
    title: 'Email',
    dataIndex: 'email',
    key: 'email',
  },
  {
    title: 'Phone',
    dataIndex: 'phone',
    key: 'phone',
  },
  {
    title: 'Process',
    dataIndex: 'process_desc',
    key: 'process_desc',
  },
  {
    title: 'Claim Time',
    dataIndex: 'prize_claim_time',
    key: 'prize_claim_time',
  },
  {
    title: 'Action',
    key: 'action',
  },
];

const data = ref([]);
// 分页配置
const pagination = ref({
  current: 1,
  pageSize: 10,
  total: 0, // 这里通常是通过后端接口获取的总记录数
});

const queryData = async params => {
  console.log('==query data params', params)
  const res = await claimHistory(params);
  console.log('===query res', res);
  if (typeof res !== 'undefined' && res.code === 200) {
    data.value = res.data.data;
    pagination.value.total = res.data.total;
    pagination.value.current = res.data.current_page
  } else {
    message.error(res.msg);
  }
  return res;
};
const {
  data: dataSource,
  run,
  loading,
  current,
  pageSize,
} = usePagination(queryData, {
  formatResult: res => res.data.data,
  pagination: {
    currentKey: 'page',
    pageSizeKey: 'results',
  },
});
console.log('===dataSource', dataSource);
const handleTableChange = (pag, filters, sorter, extra) => {
  console.log('===handleTableChange', pag, filters, sorter, extra);
  run({
    results: pag.pageSize,
    page: pag?.current,
    sortField: sorter.field,
    sortOrder: sorter.order,
    ...filters,
  });
};

</script>

<style scoped>
.site-layout-content {
  min-height: 280px;
  padding: 24px;
  background: #fff;
}

#components-layout-demo-top .logo {
  float: left;
  width: 120px;
  height: 31px;
  margin: 16px 24px 16px 0;
  background: rgba(255, 255, 255, 0.3);
}

.ant-row-rtl #components-layout-demo-top .logo {
  float: right;
  margin: 16px 0 16px 24px;
}

[data-theme='dark'] .site-layout-content {
  background: #141414;
}
</style>
